import { ArrowLeftOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, InputNumber, notification, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import xmlDisable from "../../assets/xml-disable.png";
import xml from "../../assets/xml.png";
import { startPqrDataLoader } from "../../redux/pqrReportData/actions";
import {
  FETCH_PQRDATA_REPORT_LINK_SAGA,
  FETCH_PQRDATA_SAGA,
} from "../../redux/pqrReportData/types";
import PqrTable from "../PqrReportData/PqrTable";

const PqrReportTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { isGenerating } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const boundary = queryParams.get("boundary");

  const [editedDataFromTable, setEditedDataFromTable] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const [isToleranceChanged, setIsToleranceChanged] = useState(false); // New state for tracking tolerance change

  const { weld_numbers } = useParams();

  const selectedProjectId = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_id
  );
  const selectedProjectName = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_name
  );
  const loader = useSelector((state) => state.pqrdataReducer.isPqrDataLoding);
  const savedBoundary = useSelector((state) => state.pqrdataReducer.boundary);
  const BoundaryValue = boundary ? boundary : savedBoundary;
  const [inputBoundary, setInputBoundary] = useState(BoundaryValue);

  const PqrReportData =
    useSelector((state) => state.pqrdataReducer.pqrdataList) || [];
  const reportGeneratedData = useSelector(
    (state) => state.pqrdataReducer?.reportGeneratedInfoList?.recordList
  );

  const weldNumberArray = weld_numbers ? weld_numbers.split(",").join(",") : [];
  const mapValuesToPayload = (item) => {
    let mappedValues = {
      ...(item.passName && { passName: item.passName }),
      ...(item.preHeatMin && {
        preHeatInterPassTemperatureMin: item.preHeatMin.toString(),
      }),
      ...(item.preHeatMax && {
        preHeatInterPassTemperatureMax: item.preHeatMax.toString(),
      }),
      ...(item.arcEnergyMin && { arcEnergyMin: item.arcEnergyMin.toString() }),
      ...(item.arcEnergyMax && { arcEnergyMax: item.arcEnergyMax.toString() }),
      ...(item.pulseFreqMin && {
        averagePulseFrequencyMin: item.pulseFreqMin.toString(),
      }),
      ...(item.pulseFreqMax && {
        averagePulseFrequencyMax: item.pulseFreqMax.toString(),
      }),
      ...(item.pulseTimeMin && {
        averagePulseTimeMin: item.pulseTimeMin.toString(),
      }),
      ...(item.pulseTimeMax && {
        averagePulseTimeMax: item.pulseTimeMax.toString(),
      }),
      ...(item.peakCurrentMin && {
        averagePeakCurrentMin: item.peakCurrentMin.toString(),
      }),
      ...(item.peakCurrentMax && {
        averagePeakCurrentMax: item.peakCurrentMax.toString(),
      }),
      ...(item.baseCurrentMin && {
        averageBaseCurrentMin: item.baseCurrentMin.toString(),
      }),
      ...(item.baseCurrentMax && {
        averageBaseCurrentMax: item.baseCurrentMax.toString(),
      }),
    };

    return mappedValues;
  };

  const reverseMapValues = (payload) => {
    let originalValues = {
      ...(payload.passName && { passName: payload.passName }),
      ...(payload.passName && { key: payload.passName }),
      ...(payload.preHeatInterPassTemperatureMin && {
        preHeatMin: parseFloat(payload.preHeatInterPassTemperatureMin),
      }),
      ...(payload.preHeatInterPassTemperatureMax && {
        preHeatMax: parseFloat(payload.preHeatInterPassTemperatureMax),
      }),
      ...(payload.arcEnergyMin && {
        arcEnergyMin: parseFloat(payload.arcEnergyMin),
      }),
      ...(payload.arcEnergyMax && {
        arcEnergyMax: parseFloat(payload.arcEnergyMax),
      }),
      ...(payload.averagePulseFrequencyMin && {
        pulseFreqMin: parseFloat(payload.averagePulseFrequencyMin),
      }),
      ...(payload.averagePulseFrequencyMax && {
        pulseFreqMax: parseFloat(payload.averagePulseFrequencyMax),
      }),
      ...(payload.averagePulseTimeMin && {
        pulseTimeMin: parseFloat(payload.averagePulseTimeMin),
      }),
      ...(payload.averagePulseTimeMax && {
        pulseTimeMax: parseFloat(payload.averagePulseTimeMax),
      }),
      ...(payload.averagePeakCurrentMin && {
        peakCurrentMin: parseFloat(payload.averagePeakCurrentMin),
      }),
      ...(payload.averagePeakCurrentMax && {
        peakCurrentMax: parseFloat(payload.averagePeakCurrentMax),
      }),
      ...(payload.averageBaseCurrentMin && {
        baseCurrentMin: parseFloat(payload.averageBaseCurrentMin),
      }),
      ...(payload.averageBaseCurrentMax && {
        baseCurrentMax: parseFloat(payload.averageBaseCurrentMax),
      }),
    };

    return originalValues;
  };

  const [loadPqrData, setLoadPqrData] = useState(false);
  const [excludedTlogsParsed, setExcludedTlogsParsed] = useState([]);

  const fetchPqrData = (boundaryValue) => {
    let PayloadData = {
      project_id: selectedProjectId,
      project_name: selectedProjectName,
      weld_numbers: weldNumberArray,
      boundary: boundaryValue,
    };
    const commonPayload = {
      project_id: selectedProjectId,
      project_name: selectedProjectName,
      weld_numbers: weldNumberArray,
      boundary: boundaryValue,
      shouldExecuteStopLoader: false,
    };

    setLoadPqrData(true);

    dispatch({
      type: FETCH_PQRDATA_REPORT_LINK_SAGA,
      payload: commonPayload,
      cb: (pqrData) => {
        const { max_min_data, selected_columns, boundary, excluded_tlogs_key } =
          pqrData?.recordList?.[0] || {};

        const parsedMaxMinData = JSON.parse(max_min_data || "{}")?.max_min_data;

        const parsedExcludedTlogs =
          JSON.parse(excluded_tlogs_key || "{}")?.excluded_tlogs_key || [];

        setExcludedTlogsParsed(parsedExcludedTlogs);

        const selectedColumns = JSON.parse(
          selected_columns || "{}"
        )?.selected_columns;

        let originalValuesMapped =
          parsedMaxMinData?.map((ite) => {
            return reverseMapValues(ite);
          }) || [];

        if (selectedColumns?.length > 0) {
          setVisibleColumnsAggrid(selectedColumns);
        }

        setEditedDataFromTable([...originalValuesMapped]);

        PayloadData = {
          ...PayloadData,
          ...(parsedMaxMinData && { items: parsedMaxMinData }),
          ...(selectedColumns && {
            columns_add: selectedColumns?.filter((ite) => ite != "Pass Name"),
          }),
          ...(parsedExcludedTlogs?.length && {
            excluded_tlogs: parsedExcludedTlogs,
          }),
          boundary: boundary || PayloadData.boundary,
        };
        dispatch({
          type: FETCH_PQRDATA_SAGA,
          payload: PayloadData,
          cb: () => {
            setLoadPqrData(false);
          },
          error: () => {
            setLoadPqrData(false);
          },
        });
      },
      error: () => {
        setLoadPqrData(false);
      },
    });
  };

  useEffect(() => {
    fetchPqrData(BoundaryValue);
  }, []);

  const PqrreportLink = useSelector(
    (state) => state.pqrdataReducer?.pqrReportLinkData?.recordList
  );

  const Data = PqrreportLink?.[0];

  const [hasChanged, setHasChanged] = useState(false);

  const columnsAvailable = [
    "Pass Name",
    "Pre-Heat/ Interpass Temperature",
    "Average Voltage",
    "Average Current",
    "Average Wire Feed Speed",
    "Average Oscillation Width",
    "Average Oscillation Frequency",
    "Average Travel Speed",
    "Arc Energy",
    "Average Pulse Frequency",
    "Average Pulse Time",
    "Average Peak Current",
    "Average Base Current",
  ];

  const [visitbleColumnsAggrid, setVisibleColumnsAggrid] =
    useState(columnsAvailable);

  const handleBoundaryChange = (value) => {
    setInputBoundary(value);
    setIsToleranceChanged(true);
  };

  const [isGenerateClicked, setIsGenerateClicked] = useState(false);

  const validateMinMax = (item) => {
    const validations = [
      { min: "preHeatMin", max: "preHeatMax" },
      { min: "arcEnergyMin", max: "arcEnergyMax" },
      { min: "pulseFreqMin", max: "pulseFreqMax" },
      { min: "pulseTimeMin", max: "pulseTimeMax" },
      { min: "peakCurrentMin", max: "peakCurrentMax" },
      { min: "baseCurrentMin", max: "baseCurrentMax" },
    ];

    for (const { min, max } of validations) {
      if (
        item[min] !== undefined &&
        item[max] !== undefined &&
        Number(item[min]) > Number(item[max])
      ) {
        return false;
      }
    }

    return true;
  };

  const handleReGenerateClick = () => {
    if (inputBoundary === null) {
      notification.warning({
        message: "Please enter a valid boundary value to re-generate the data.",
      });
      return;
    }

    setIsGenerateClicked(true);

    let isInvalid = editedDataFromTable
      ?.map((ite) => {
        let { key, ...rest } = ite;
        console.log(key, "key");
        return validateMinMax(rest);
      })
      .filter((ite) => ite === false);

    if (isInvalid.length === 0) {
      const sortedData = visitbleColumnsAggrid
        ?.filter((ite) => ite != "Pass Name")
        .sort((a, b) => {
          return columnsAvailable.indexOf(a) - columnsAvailable.indexOf(b);
        });

      let payload = {
        project_id: selectedProjectId,
        project_name: selectedProjectName,
        weld_numbers: weldNumberArray,
        boundary: inputBoundary,
        columns_add: sortedData,
        items: editedDataFromTable?.map((ite) => {
          let { key, ...rest } = ite;
          console.log(key);
          return {
            ...mapValuesToPayload(rest),
          };
        }),
        excluded_tlogs: excludedTlogsParsed,
      };

      const commonPayload = {
        project_id: selectedProjectId,
        project_name: selectedProjectName,
        weld_numbers: weldNumberArray,
        boundary: inputBoundary,
        shouldExecuteStopLoader: false,
      };
      dispatch(startPqrDataLoader());
      dispatch({
        type: FETCH_PQRDATA_SAGA,
        payload,
        cb: () => {
          history.push(
            `/pqr-table-data/${weld_numbers}?boundary=${inputBoundary}`
          );
          dispatch({
            type: FETCH_PQRDATA_REPORT_LINK_SAGA,
            payload: commonPayload,
            cb: (pqrData) => {
              const { selected_columns } = pqrData?.recordList?.[0] || {};
              const selectedColumns = JSON.parse(
                selected_columns || "{}"
              )?.selected_columns;
              if (selectedColumns?.length > 0) {
                setVisibleColumnsAggrid(selectedColumns);
              }
            },
          });
        },
      });
    } else {
      notification.warning({ message: "Check your input values" });
    }
  };

  const fetchPQRReportLinkData = () => {
    const payload = {
      project_id: selectedProjectId,
      project_name: selectedProjectName,
      weld_numbers: weldNumberArray,
      boundary: inputBoundary,
    };

    dispatch({
      type: FETCH_PQRDATA_REPORT_LINK_SAGA,
      payload,
    });
    setIsGenerateClicked(false);
  };

  const maxMinData = Data?.max_min_data
    ? JSON.parse(Data.max_min_data).max_min_data
    : [];

  const matchingReport = reportGeneratedData?.find((report) => {
    const reportWeldNumbers = report.weld_numbers;
    return reportWeldNumbers === weldNumberArray;
  });
  const weldNumbersMatch = Data?.weld_numbers == weldNumberArray;

  const handleDownload = () => {
    if (matchingReport?.pqr_report_url) {
      window.open(Data?.pqr_report_url, "_blank");
    } else if (weldNumbersMatch && Data?.pqr_report_url !== null) {
      window.open(Data?.pqr_report_url, "_blank");
    } else {
      console.log("No matching report or URL not found");
    }
  };

  return (
    <>
      <div className="slogweld-title">
        <Link to="/data360-home/pqr-report">
          <div className="back_equip">
            <Tooltip title={"Back"}>
              <ArrowLeftOutlined />
            </Tooltip>
            <h2 className="slogweld-header-active">PQR Report</h2>
          </div>
        </Link>

        <div className="back_equip-unActive">
          <ArrowLeftOutlined />
          <h2 className="slogweld-header-weldnuber">
            {t("slogColumntitle.weld")} {weldNumberArray}
          </h2>
        </div>
        {!loader && (
          <>
            <div className="boundary-input">
              <label className="tolerance-lable">Tolerance</label>
              <InputNumber
                defaultValue={inputBoundary}
                formatter={(value) => `${value}%`}
                onChange={handleBoundaryChange}
                className="re-generate-input"
              />
              <Button
                type="primary"
                className="re-generate-btn"
                onClick={(data) => {
                  handleReGenerateClick(data);
                }}
                disabled={!hasChanged && !isEdited && !isToleranceChanged}
              >
                Generate
              </Button>
              <Tooltip
                placement="topLeft"
                title={
                  !(
                    matchingReport?.pqr_report_url ||
                    (weldNumbersMatch && Data?.pqr_report_url !== null)
                  )
                    ? "Please wait until the report generates."
                    : null
                }
              >
                {isGenerateClicked ||
                !(
                  (matchingReport?.pqr_report_url &&
                    matchingReport?.pqr_report_url == "") ||
                  (weldNumbersMatch &&
                    Data?.pqr_report_url !== null &&
                    Data?.pqr_report_url !== "")
                ) ? (
                  <img
                    src={xmlDisable}
                    alt="Download PQR Report"
                    className="re-generate-btn-save-pd-disable"
                  />
                ) : (
                  <img
                    src={xml}
                    alt="Download PQR Report"
                    onClick={handleDownload}
                    className="re-generate-btn-save-pd"
                  />
                )}
              </Tooltip>

              {((isGenerating && !Data?.pqr_report_url) ||
                isGenerateClicked ||
                !(
                  matchingReport?.pqr_report_url ||
                  (weldNumbersMatch && Data?.pqr_report_url !== null)
                )) && (
                <Tooltip placement="topLeft" title="Reload">
                  <Button
                    className="refresh-download"
                    onClick={() => fetchPQRReportLinkData()}
                  >
                    <ReloadOutlined />
                  </Button>
                </Tooltip>
              )}
            </div>
          </>
        )}
      </div>
      <PqrTable
        weld_number={weldNumberArray}
        loadPqrData={loadPqrData}
        PqrReportData={PqrReportData}
        setIsEdited={setIsEdited}
        editedDataFromTable={editedDataFromTable}
        maxMinData={maxMinData}
        boundary={boundary}
        setEditedDataFromTable={setEditedDataFromTable}
        visitbleColumnsAggrid={visitbleColumnsAggrid}
        setVisibleColumnsAggrid={(data) => {
          setHasChanged(true);
          setVisibleColumnsAggrid(data);
        }}
      />
    </>
  );
};

export default PqrReportTable;
